import App from 'libs/app';
import tudFlyout from './tud.flyout';

App.registerReadyHandler('organization-navigation', () => {
    tudFlyout();
});
